import { selectIsFirstWorkoutCompleted } from 'store/personalPlan/selectors';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { useFeatureFlagWithAQA } from 'services/Eppo';

import { useSelector } from 'hooks';

import { reasons, updatedReasons } from '../constants';

const useGetReasons = () => {
    const { value: variant } = useFeatureFlagWithAQA<string>({
        flagKey: ONGOING_EXPERIMENTS.CancellationQuizReasonsUpdate,
        defaultValue: 'control',
        type: 'string',
    });
    const isFirstWorkoutCompleted = useSelector(selectIsFirstWorkoutCompleted);

    // If variant: a win, then need to discuss possibility to use initial_setup instead of isFirstWorkoutCompleted, to reduce addition requests
    return variant === 'a' ? updatedReasons(isFirstWorkoutCompleted) : reasons;
};

export default useGetReasons;
